import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SessionStoreRepository } from "../shared/repositories/session.repository";


@Component({
    selector: "web-patient-auth",
    templateUrl: "./auth.component.html",
    styleUrls: ["./auth.component.scss"],
    standalone: false
})
export class AuthComponent implements OnInit {
    constructor(
        private readonly sessionService: SessionStoreRepository,
        private readonly router: Router
    ) { }

    ngOnInit(): void {
        if (this.sessionService.isLoggedIn()) {
            this.router.navigate(["/authenticated"]);
        }
        this.router.navigate(["/welcome"]);
    }
}
